import {
    ButtonGroup,
    Button,
} from '@mui/material';
import {
    BarChartRounded,
    TimelineRounded,
} from '@mui/icons-material';

const ChartType = {
    TIMELINE: 'timeline',
    BAR: 'bar',
}

const ChartSwitcher = ({ chartType, setChartType, size }) => {
    return (
        <ButtonGroup 
            variant="outlined" 
            aria-label="Chart types button group" 
            size={size}
        >
            <Button
                variant={chartType === ChartType.BAR ? 'contained' : 'outlined'}
                onClick={() => setChartType(ChartType.BAR)}
            >
                <BarChartRounded/>
            </Button>
            <Button
                variant={chartType === ChartType.TIMELINE ? 'contained' : 'outlined'}
                onClick={() => setChartType(ChartType.TIMELINE)}
            >
                <TimelineRounded/>
            </Button>
        </ButtonGroup>
    );
};

export default ChartSwitcher;

export {
    ChartType,
}